import { render, staticRenderFns } from "./StudentLulus.vue?vue&type=template&id=6f168d5e&"
import script from "./StudentLulus.vue?vue&type=script&lang=js&"
export * from "./StudentLulus.vue?vue&type=script&lang=js&"
import style0 from "./StudentLulus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports